import { parameterize } from '../parameterize';
import { mergeReduce } from '../parse/merge';
import { getApiUrl, getAppUrl } from '../../urls';
import entries from 'lodash/entries';
import mapKeys from 'lodash/mapKeys';

/**
 * Will construct an API url from a given list of allowed parameters and the
 * parameters requested. If a parameter isn't allowed, it is filtered out.
 *
 * @param {string|function} path
 *
 * @param {string} path - a string path. Eg. `/accounts/me`
 * @param {string[]} allowedProps - an array of the allowed parameters of the query
 *     string or post body.
 * @param {object} forcedProps - props that will be included if they aren't already defined.
 * @param {object} defaultProps - props that are added by default and can be overridden.
 * @param {object} requestedProps - the object containing all of this request's parameters.
 * return {string} the url to the api endpoint
 */

export default function buildFetchApiUrl(
  path: string = '',
  allowedProps: string[] = [],
  forcedProps: any = {},
  defaultProps: any = {},
  requestedProps: any = {},
  shouldUseAppUrl: boolean = false,
): string {
  let params = '';
  // remove `[]` at the end in the params if already present
  // this is to support rails style query params(filter)
  let requested = mapKeys(
    { ...defaultProps, ...requestedProps },
    (value, key) => key.replace(/\[\]$/g, ''),
  );

  if (allowedProps.length) {
    params = parameterize(
      entries(requested)
        .filter(([k, v]) => allowedProps.includes(k))
        .map(([k, v]) => ({ [k]: v }))
        .reduce(mergeReduce, {}),
    );
  }

  if (Object.keys(forcedProps).length > 0) {
    params += `${params.length > 0 ? '&' : ''}${parameterize(forcedProps)}`;
  }

  const url = !shouldUseAppUrl ? getApiUrl() : getAppUrl();

  return !params.length ? `${url}${path}` : `${url}${path}?${params}`;
}
